import React from 'react';
import CopyButton from '../utils/CopyButton';
import fromReactElementToCopyable from '../utils/fromReactElementToCopyable';

const DefaultTypeNumber = props => {
  const {
    data,
    schema,
    path = [],
    enableCopyField,
    customCopyFieldComponent,
  } = props;

  const copyableText = fromReactElementToCopyable(data);

  return (
    <div className={`default-type-number depth-${path.length}`}>
      <strong className="default-type-number-title">{schema.title}</strong>{' '}
      <span className="default-type-number-value">{data}</span>
      {enableCopyField && (
        <CopyButton
          text={copyableText}
          customButton={customCopyFieldComponent}
        />
      )}
    </div>
  );
};

export default DefaultTypeNumber;
